let _show = null;

const toastActions = {
  register: (fn) => {
    _show = fn;
  },
  show: (message) => {
    _show && _show(message);
  },
};

export default toastActions;
